import { styled as t, keyframes as n } from "styled-components";
import { TextInputSkeletonContainer as o } from "../../../../components/TextInput/style.js";
import { MediaQuery as e } from "../../../../styles/variables.js";
import { Button as i } from "../../../../components/Button/index.js";
import { CommentAvatarContainer as a } from "../CommentAvatar/style.js";
import { CommentSuggestionsCarousel as r } from "../../CommentSuggestionsCarousel/index.js";
import { Icon as m } from "../../../../components/Icon/index.js";
const g = t.div`
  display: flex;
  flex-direction: column;
`, C = t.div`
  display: flex;
  flex-direction: row;
`, v = t.div`
  display: grid;
  gap: 4px;
  grid-template-columns: auto minmax(0px, 1fr) auto;
  grid-template-areas: 'avatar textArea sendButton';

  ${a} {
    top: 2px;
    position: relative;
  }
`, y = t.div`
  grid-area: sendButton;
  align-self: flex-end;

  &[aria-hidden='true'] {
    display: none;
  }
`, S = t(i)`
  padding: 0;
  width: 36px;
  height: 36px;
  top: -2px;
  font-size: 24px;

  & > i {
    margin-left: 1px;
  }
`, I = t(o)`
  margin-left: 8px;
  grid-area: textArea;
  @media ${e.SCREEN_MD_UP} {
    margin-left: 4px;
  }
`;
t(
  r
)`
  margin-left: 0;
  width: 100%;

  @media ${e.SCREEN_MD_UP} {
    margin-left: 40px;
    width: calc(100% - 30px);
  }
`;
const p = n`
0%, 100% {
    transform: scale(1);
  }
50% {
    transform: scale(1.4);
  }
`, h = t(m)`
  animation: ${p} 1s infinite;
`;
export {
  C as CommemtInputAvatarContainer,
  g as CommentInputContainer,
  v as CommentInputContent,
  I as CommentInputTextSkeleton,
  S as CommentSubmitButton,
  y as CommentSubmitButtonContainer,
  h as IconCommentSuggestion,
  p as rotationKeyframes
};
